<ion-header class="ion-no-border page">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/dashboard"></ion-back-button>
    </ion-buttons>
    <ion-title mode="ios">
      <div  (click)="goHome()" class="header-logo">&nbsp;</div>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="showMenu()" class="menu" [attr.aria-label]="'ARIA.MENU.BUTTON.LABEL_0' | translate">
        <ion-icon slot="icon-only" aria-hidden="true"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="page-title" translate>{{dialogTitle}}</div>

</ion-header>

<ion-content class="ion-padding master page2">
  <div class="v-box" style="height: 100%">

    <ion-list>
    <ng-template ngFor let-item let-i="index" [ngForOf]="questions">

      <ng-template [ngIf]="item.answerType === '1'">
        <scale-question (valueChange)="answerChanged(item._id, $event)" [title]="getQuestionTitle(item)" [minLabel]="getMinLabel(item)" [maxLabel]="getMaxLabel(item)"></scale-question>
      </ng-template>
      <ng-template [ngIf]="item.answerType === '2'">
        <likert-question (valueChange)="answerChanged(item._id, $event)" [title]="getQuestionTitle(item)" [minLabel]="getMinLabel(item)" [maxLabel]="getMaxLabel(item)"></likert-question>
      </ng-template>
      <ng-template [ngIf]="item.answerType === '3'">
        <yes-no-question (valueChange)="answerChanged(item._id, $event)" [title]="getQuestionTitle(item)"></yes-no-question>
      </ng-template>
      <ng-template [ngIf]="item.answerType === '4'">
        <text-question (valueChange)="answerChanged(item._id, $event)" [title]="getQuestionTitle(item)"></text-question>
      </ng-template>
      <ng-template [ngIf]="item.answerType === '5'">
        <mc-question (valueChange)="answerChanged(item._id, $event)" [title]="getQuestionTitle(item)" [options]="item.options"></mc-question>
      </ng-template>

    </ng-template>
    </ion-list>

  </div>
</ion-content>

<ion-footer class="ion-padding page2">
  <ion-button fill="solid" shape="round" expand="block" color="light" [disabled]="!isValid" (click)="onNextClick()">
    <div translate>COMMON.FINISH</div>
  </ion-button>
  <ion-button fill="solid" shape="round" expand="block" color="light" [disabled]="!isValid" *ngIf="goal" (click)="onGoalClick()">
    <div translate>COMMON.GOAL</div>
  </ion-button>
</ion-footer>
